<span class="filter-label">{{ config.labelKey | locLabel }}</span>
<app-select-input
  *ngIf="control"
  [formControl]="control"
  [multiple]="config.multiple"
  [searchable]="!!config.searchable"
  [options]="config.options"
  [outline]="false"
  [footer]="false"
  class="filter"
  [width]="config.width"
></app-select-input>
